module.exports = __webpack_public_path__ + "files/6d1549003f66d7005917ef0241083097.png";